<!-- =========================================================================================
    File Name: CompanyEdit.vue
    Description: Edit Company
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">

        <h4> Edit Company details </h4> <br/>        

        <div class="p-6">
                        
            <form @submit.prevent="submitForm">

                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <vs-input class="w-full" label-placeholder="Company Name" v-model="CompanyName" v-validate="'required'" name="CompanyName" />
                        <span class="text-danger text-sm" v-show="errors.has('CompanyName')">{{ errors.first('CompanyName') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <vs-input class="w-full" label-placeholder="Gst Number" v-model="GstNumber" v-validate="'min:15'" :maxlength="15" name="GstNumber" />
                        <span class="text-danger text-sm" v-show="errors.has('GstNumber')">{{ errors.first('GstNumber') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <vs-input class="w-full" label-placeholder="Pan Number" v-model="PanNumber" v-validate="'min:10'" :maxlength="10" name="PanNumber" />
                        <span class="text-danger text-sm" v-show="errors.has('PanNumber')">{{ errors.first('PanNumber') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full mb-3">
                        <vs-input class="w-full" label-placeholder="Address" v-model="Address" v-validate="'required'" name="Address" />
                        <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <span class="text-primary text-sm vs-placeholder-label"> City Code </span>
                        <v-select v-model="CityCode" name="CityCode" :value="CityCode" :options="CityCodeOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('CityCode')">{{ errors.first('CityCode') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <vs-input class="w-full" label-placeholder="Contact Number" v-model="ContactNumber" v-validate="'required|numeric|min:10'" :maxlength="10" name="ContactNumber" />
                        <span class="text-danger text-sm" v-show="errors.has('ContactNumber')">{{ errors.first('ContactNumber') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <vs-input class="w-full" label-placeholder="Landline Number" v-model="LandlineNumber" v-validate="''" name="LandlineNumber" />
                        <span class="text-danger text-sm" v-show="errors.has('LandlineNumber')">{{ errors.first('LandlineNumber') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <h4>Select Logo</h4>
                        <input type="file" ref="logo" >
                        <span class="text-danger text-sm" v-show="errors.has('Logo')">{{ errors.first('Logo') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <vs-input class="w-full" label-placeholder="Website" v-model="Website" v-validate="''" name="Website" />
                        <span class="text-danger text-sm" v-show="errors.has('Website')">{{ errors.first('Website') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <vs-input class="w-full" label-placeholder="Email" v-model="Email" v-validate="'email'" name="Email" />
                        <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                    </div>
                </div>

                <div class="vx-row">

                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <vs-input class="w-full" label-placeholder="Short Code" v-model="ShortCode" v-validate="'required'" name="ShortCode" :maxlength="6" />
                        <span class="text-danger text-sm" v-show="errors.has('ShortCode')">{{ errors.first('ShortCode') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/3 w-full mb-3">
                        <span class="text-primary text-sm vs-placeholder-label"> Active Status </span>
                        <v-select v-model="ActiveStatus" name="ActiveStatus" :value="ActiveStatus" :options="ActiveStatusOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required'" > </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('ActiveStatus')">{{ errors.first('ActiveStatus') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full text-right mb-3">
                        <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import { Validator } from 'vee-validate';
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';

const dict = {
  custom: {
    CompanyName: { required: 'Company Name should not be empty' },
    Address: { required: 'Address should not be empty' },
    CityCode: {
        required: 'City Code should not be empty',
        numeric: 'Enter valid City Code', 
    },
    GstNumber: {
        min: 'Gst Number should contain 15 characters', 
    },
    PanNumber: {
        min: 'Pan Number should contain 10 characters', 
    },
    ContactNumber: {
        required: 'Contact Number should not be empty',
        min: 'Contact Number is invalid', 
        numeric: 'Contact Number is invalid', 
    },
    LandlineNumber: { required: 'Landline Number should not be empty' },
    Logo: { required: 'Logo should not be empty' },
    Website: { required: 'Website should not be empty' },
    Email: {
        email: 'Email is invalid', 
    },
    ActiveStatus: { required: 'Active Status should not be empty' },
    LoginName: { required : 'Login Name should not be empty', },
    ShortCode: { required : 'Short Code should not be empty', },
    FinancialYear: { required : 'Financial Year should not be empty', },
    StartDate: { required : 'Financial Year Start Date should not be empty', },
  }
};

// register custom messages
Validator.localize('en', dict);

export default{
    mixins: [common],
    components: {
        'v-select': vSelect,
        Datepicker
    },
    props: {
        editRecordPrompt: {
            type: Boolean,
            required: true,
        },
        recordIndex: {
            type: Number,
            required: true,
        }        
    },    
    data() {
        return {
            // activePrompt: false,

            CompanyCategory: this.$store.state.companyDetails.dataArray[this.recordIndex].CategoryId,
            LoginName: this.$store.state.companyDetails.dataArray[this.recordIndex].LoginName,
            ParentId: this.$store.state.companyDetails.dataArray[this.recordIndex].ParentId,
            CompanyId: this.$store.state.companyDetails.dataArray[this.recordIndex].CompanyId,
            CompanyName: this.$store.state.companyDetails.dataArray[this.recordIndex].CompanyName,
            ShortCode: this.$store.state.companyDetails.dataArray[this.recordIndex].CompanyTitle,
            Address: this.$store.state.companyDetails.dataArray[this.recordIndex].Address,
            CityCode: this.$store.state.companyDetails.dataArray[this.recordIndex].CityCode,
            GstNumber: this.$store.state.companyDetails.dataArray[this.recordIndex].GstNumber,
            PanNumber: this.$store.state.companyDetails.dataArray[this.recordIndex].PanNumber,
            ContactNumber: this.$store.state.companyDetails.dataArray[this.recordIndex].ContactNumber,
            LandlineNumber: this.$store.state.companyDetails.dataArray[this.recordIndex].LandlineNumber,
            Logo: this.$store.state.companyDetails.dataArray[this.recordIndex].Logo,
            Website: this.$store.state.companyDetails.dataArray[this.recordIndex].Website,
            Email: this.$store.state.companyDetails.dataArray[this.recordIndex].Email,
            ActiveStatus: this.$store.state.companyDetails.dataArray[this.recordIndex].ActiveStatus,
            FinancialYear: this.$store.state.companyDetails.dataArray[this.recordIndex].FinancialYear,
            StartDate: this.$store.state.companyDetails.dataArray[this.recordIndex].StartDate,

            LogoImage: '',

            CityCodeOptions: [],
            ActiveStatusOptions: this.selectListActiveStatus(),
            FinancialYearOptions : this.selectListFinancialYear(),
        }
    },
    computed: {
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideEditRecordPrompt');
        },
        updateRecordDetails() {

            var token = this.$session.get('token');

            this.LogoImage = this.$refs.logo.files[0];

            let formData = new FormData();
            formData.append('token',token);
            formData.append('CompanyCategory', this.CompanyCategory);            
            formData.append('ParentId', this.ParentId);
            formData.append('CompanyId',this.CompanyId);
            formData.append('CompanyName',this.CompanyName);
            formData.append('Address',this.Address);
            formData.append('CityCode',this.CityCode);
            formData.append('GstNumber',this.GstNumber);
            formData.append('PanNumber',this.PanNumber);
            formData.append('ContactNumber',this.ContactNumber);
            formData.append('LandlineNumber',this.LandlineNumber);
            formData.append('Logo', this.LogoImage);
            formData.append('Website',this.Website);
            formData.append('Email',this.Email);
            formData.append('ActiveStatus',this.ActiveStatus);
            formData.append('ShortCode', this.ShortCode);

            console.log('formData='+JSON.stringify(formData));

            var server_url = companyConfig.apiURL;
            var url = server_url+'lib/api/company/update';
            var where = {};
            var list_url = server_url+'lib/api/company/lists';
            var list_where = {};
            var headers = 'multipart/form-data';
            var record={};
            record.token = token;
            record.headers = headers;
            record.update_url = url;
            record.where=where;
            record.form = formData;
            record.list_url = list_url;
            record.list_where = list_where;
            console.log('record='+JSON.stringify(record));
            record.loading=this.$vs.loading;
            record.notify=this.$vs.notify;
            record.http=this.$http;            
            this.$store.dispatch('companyDetails/updateRecordDetails', record);

            this.closePrompt();
        },
        init() {
            // clear all fileds in todo
            this.PriceGroupId = this.$store.state.companyDetails.dataArray[this.recordIndex].PriceGroupId,
            this.PriceGroupName = this.$store.state.companyDetails.dataArray[this.recordIndex].PriceGroupName,
            this.PriceGroupDescription = this.$store.state.companyDetails.dataArray[this.recordIndex].PriceGroupDescription,
            
            this.$parent.editRecordPrompt = false;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.updateRecordDetails();
            })
        }
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            const token=this.$session.get('token');
            console.log('token='+token);

            var selectbox1_source = 'CityCode'
            var selectbox1_destination = 'CityCodeOptions'
            var selectbox1_url = 'lib/api/data/get_city_options'
            var selectbox1_conditions_array = {
                'city_details_district_details_id >=': 1
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url)

        }
    },    
}
</script>
